"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleModal = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const SimpleModal = (props) => {
    var _a;
    return (react_1.default.createElement(Modal_1.default, { className: "simple-modal " + ((_a = props.className) !== null && _a !== void 0 ? _a : ""), show: true, onHide: props.onClose, animation: false, centered: true, size: props.size },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null, props.title)),
        react_1.default.createElement(Modal_1.default.Body, null, props.body),
        react_1.default.createElement(Modal_1.default.Footer, null,
            props.onOk && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Button_1.default, { variant: "primary", style: { minWidth: "110px" }, onClick: props.onOk, autoFocus: true }, "Ok"),
                react_1.default.createElement(Button_1.default, { variant: "secondary", style: { minWidth: "110px" }, onClick: props.onClose }, "Schliessen"))),
            !props.onOk && (react_1.default.createElement(Button_1.default, { variant: "secondary", style: { minWidth: "110px" }, onClick: props.onClose, autoFocus: true }, "Schliessen")))));
};
exports.SimpleModal = SimpleModal;
